import * as React from 'react';
import classnames from 'classnames';

type Props = {
  children: React.ReactNode,
  isVisible: boolean
};

const TutorialCarouselSlide = (
  {
    children,
    isVisible
  }: Props
): JSX.Element => {
  const slideClasses = classnames({
    'tutorial-carousel-slide': true,
    'tutorial-carousel-slide--visible': isVisible
  });

  return (
    <section className={slideClasses}>
      {children}
    </section>
  );
};

export default TutorialCarouselSlide;
